import React from 'react';
import styled from 'styled-components';
import { Heading3, P, Link, Strong, Margin } from '@ovotech/element-v5';
import { CreditCard } from './CreditCard';
import useWindowDimensions from '@/src/utils/hooks/useWindowDimensions';
import {
  RewardsCard,
  RewardsCardContent,
  RewardsCardTextContent,
  RewardsCardActions,
  RewardsCardImageContainer,
} from './RewardsCard';
import { useAnalytics } from '@ovotech/ui-tools';
import { ALL_REWARDS_PAGE } from '@/src/constants/analytics';

const SubHeading = styled(P)`
  color: ${({ theme }) => theme.colors.brand.ovo};
`;

const Heading = styled(Heading3)`
  color: ${({ theme }) => theme.colors.brand.midnight};
`;

type DirectDebitProps = {
  analyticsProps: Record<string, unknown>;
};

export const DirectDebit = ({ analyticsProps }: DirectDebitProps) => {
  const { isMobile } = useWindowDimensions();
  const { dispatch } = useAnalytics();

  const onSetUpDirectDebitClick = () =>
    dispatch({
      name: ALL_REWARDS_PAGE.DIRECT_DEBIT.CLICKED_SETUP_DD,
      type: 'click',
      properties: analyticsProps,
    });

  const onHowDirectDebitWorksClick = () =>
    dispatch({
      name: ALL_REWARDS_PAGE.DIRECT_DEBIT.CLICKED_HOW_DD_WORKS,
      type: 'click',
      properties: analyticsProps,
    });

  return (
    <RewardsCard>
      <RewardsCardContent>
        <RewardsCardTextContent>
          <SubHeading size="md">
            <Strong>Spread your costs evenly</Strong>
          </SubHeading>
          <Heading>Set up a Direct Debit</Heading>

          <Margin top={4}>
            <P size="md">
              It's easy to set up, and you can adjust your monthly payments
              anytime.
            </P>
          </Margin>

          <RewardsCardActions>
            <Link
              href="https://account.ovoenergy.com/payments/direct-debit/setup"
              variant="surface"
              onClick={onSetUpDirectDebitClick}
            >
              Set up Direct Debit
            </Link>
            <Link
              href="https://www.ovoenergy.com/help/article/how-do-direct-debits-work"
              variant="outline"
              inline
              opensInNewWindow
              onClick={onHowDirectDebitWorksClick}
            >
              How Direct Debit works
            </Link>
          </RewardsCardActions>
        </RewardsCardTextContent>

        <RewardsCardImageContainer>
          <CreditCard size={isMobile ? 80 : 144} />
        </RewardsCardImageContainer>
      </RewardsCardContent>
    </RewardsCard>
  );
};
